"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./components/Facepile/index"), exports);
//# sourceMappingURL=Facepile.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/Facepile.js
// module id = ../node_modules/office-ui-fabric-react/lib/Facepile.js
// module chunks = 1